module.exports = __webpack_public_path__ + "static/media/others-icon.1c65ece0.svg";